import * as React from 'react';
import $ from "jquery";
import Common from '../utilities/common';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, TextField } from '@mui/material';
import { TipoViaVariacion } from './TipoViaVariacion';
import { TipoVia } from '../TiposVia/TipoVia';
import ErrorDialog from '../utilities/ErrorDialog';

export interface ITipoViaVariacionEditProps {
    open: boolean;
    onClose?: Function;
    onSave?: Function;
    selectedItem: TipoViaVariacion | undefined;
}

export interface ITipoViaVariacionEditState {
    open: boolean;
    hasErrors: boolean;
    errorMessage: string;
    tiposVia: TipoVia[];
    openErroDialog: boolean;
}

export default class TipoViaVariacionEdit extends React.Component<ITipoViaVariacionEditProps, ITipoViaVariacionEditState> {
    _tipoViaVaracion: TipoViaVariacion = new TipoViaVariacion();
    _id: number = -1;
    
    public constructor(props: ITipoViaVariacionEditProps) {
        super(props);

        this.state = {
            open: false,
            hasErrors: false,
            errorMessage: '',
            tiposVia: [],
            openErroDialog: false
        }
    }

    componentDidMount(): void {
        this.GetTiposVia();
    }

    componentWillReceiveProps(nextProps: Readonly<ITipoViaVariacionEditProps>, nextContext: any): void {
        if(nextProps.selectedItem != null) {
            this._tipoViaVaracion = nextProps.selectedItem;
        }

        this.setState({
            open: nextProps.open
        });
    }

    public render(): React.ReactElement<{}> {
        return (
            <React.Fragment>
                <Dialog open={this.state.open} fullWidth>
                    <DialogTitle>
                        Modificar tipo de vía
                    </DialogTitle>
                    <DialogContent>
                        {
                            this.state.hasErrors && (
                                <Alert severity="error" style={{marginBottom: '10px'}}>
                                    {
                                        this.state.errorMessage
                                    }
                                </Alert>
                            )
                        }
                        <Box>
                            <FormControl required fullWidth variant="standard">
                                <InputLabel id="labelComunidadAutonoma">Seleccione un tipo de vía</InputLabel>
                                <Select label="Seleccione un tipo de vía" defaultValue={this._tipoViaVaracion.tipoVia} labelId='labelComunidadAutonoma' onChange={(event: SelectChangeEvent) => {
                                    this._tipoViaVaracion.tipoVia = event.target.value;
                                }}>
                                    {
                                        this.state.tiposVia.map((value: TipoVia, index: number) => {
                                            return (
                                                <MenuItem value={value.nombre}>
                                                    {
                                                        value.nombre
                                                    }
                                                </MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </FormControl>
                            <FormControl fullWidth style={{marginBottom: '20px'}}>
                                <TextField required variant='standard' label='Nombre' defaultValue={this._tipoViaVaracion.nombre} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    if(event.target.value == '') {
                                        this.setState(
                                            {
                                                hasErrors: true,
                                                errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios o seleccione un archivo.'
                                            }
                                        );
                                    }
                                    else {
                                        this.setState(
                                            {
                                                hasErrors: false,
                                                errorMessage: ''
                                            }
                                        );
                                        this._tipoViaVaracion.nombre = event.target.value;
                                    }
                                }}></TextField>
                            </FormControl>
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.Update.bind(this)}>OK</Button>
                        <Button onClick={this.Close.bind(this)}>Cancelar</Button>
                    </DialogActions>
                </Dialog>
                <ErrorDialog open={this.state.openErroDialog} onClose={this.Close.bind(this)} />
            </React.Fragment>
        )
    }

    private Close() {
        this.setState(
            {
                open: false,
                openErroDialog: false,
                hasErrors: false,
                errorMessage: ''
            }
        );

        if(this.props.onClose != null) {
            this.props.onClose();
        }
    }

    private Update() {
        if(this._tipoViaVaracion.nombre == '' || this._tipoViaVaracion.nombre == null) {
            this.setState({
                hasErrors: true,
                errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios o seleccione un archivo.'
            })
            return;
        }

        let url = `${Common.END_POINT}/masters/tipoviavariaciones/${this._tipoViaVaracion.id}/update`;
        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(this._tipoViaVaracion),
                dataType: "json",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done(() => {
            if(this.props.onSave != null) {
                this.props.onSave();
            }

            this._tipoViaVaracion = new TipoViaVariacion();
        }).fail((jqXHR, textStatus, errorThrown) => {
            this.setState(
                {
                    open: false,
                    openErroDialog: true
                }
            );
    
            if(this.props.onSave != null) {
                this.props.onSave();
            }

            this._tipoViaVaracion = new TipoViaVariacion();
        });
    }

    private GetTiposVia(): void {
        let url = `${Common.END_POINT}/masters/tiposVia`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            console.log(response);
            this.setState(
                {
                    tiposVia: response
                }
            );
        })
    }
}